import { PitchSlide } from './slides';
import { getPitchTemplateOrDefault } from './pitchTemplates';

const cloneSlides = (slides: PitchSlide[]): PitchSlide[] => JSON.parse(JSON.stringify(slides));

/** Slides used when creating a deck manually without AI. */
export const createStarterSlides = (templateId?: string): PitchSlide[] => {
  if (templateId) {
    return cloneSlides(getPitchTemplateOrDefault(templateId).sampleSlides);
  }

  return [
    {
      id: 'intro',
      title: 'Your pitch title',
      highlights: [
        'Describe the problem you solve',
        'Explain your solution in one line',
        'Share a traction highlight',
      ],
      imageUrl: 'https://loremflickr.com/800/600/startup,presentation',
      imageAlt: 'Pitch deck photo',
      tabLabel: 'INTRO',
    },
  ];
};
